import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\RemoveAssignedPeopleController::__invoke
* @see app/Http/Controllers/Planning/RemoveAssignedPeopleController.php
* @route '/api/planning/{event}/people/remove'
*/
const RemoveAssignedPeopleController = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: RemoveAssignedPeopleController.url(args, options),
    method: 'delete',
})

RemoveAssignedPeopleController.definition = {
    methods: ["delete"],
    url: '/api/planning/{event}/people/remove',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Planning\RemoveAssignedPeopleController::__invoke
* @see app/Http/Controllers/Planning/RemoveAssignedPeopleController.php
* @route '/api/planning/{event}/people/remove'
*/
RemoveAssignedPeopleController.url = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { event: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { event: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            event: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
    }

    return RemoveAssignedPeopleController.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\RemoveAssignedPeopleController::__invoke
* @see app/Http/Controllers/Planning/RemoveAssignedPeopleController.php
* @route '/api/planning/{event}/people/remove'
*/
RemoveAssignedPeopleController.delete = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: RemoveAssignedPeopleController.url(args, options),
    method: 'delete',
})

export default RemoveAssignedPeopleController